var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDlpAttCommunicationGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 4,
    fill: "#14BF96"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.625 12.5625C17.625 15.2422 15.0547 17.375 11.9375 17.375C10.8711 17.375 9.91406 17.1562 9.06641 16.7188C8.38281 17.0742 7.50781 17.375 6.44141 17.375C6.35938 17.375 6.27734 17.3477 6.25 17.2656C6.22266 17.1836 6.22266 17.1016 6.30469 17.0469C6.30469 17.0195 6.93359 16.3633 7.37109 15.4609C6.66016 14.6406 6.25 13.6562 6.25 12.5625C6.25 9.91016 8.79297 7.75 11.9375 7.75C15.0547 7.75 17.625 9.91016 17.625 12.5625ZM22.6289 19.8906C23.0664 20.7656 23.668 21.3945 23.668 21.4219C23.7227 21.4766 23.75 21.5586 23.7227 21.6406C23.6953 21.7227 23.6133 21.75 23.5312 21.75C22.5469 21.75 21.6992 21.4766 21.0156 21.1758C20.2773 21.5312 19.4023 21.75 18.5 21.75C16.0117 21.75 13.9609 20.2188 13.3867 18.1133C16.3125 17.5391 18.5 15.2695 18.5 12.5625C18.5 12.4258 18.4727 12.2891 18.4727 12.1523C18.4727 12.1523 18.4727 12.125 18.5 12.125C21.3984 12.125 23.75 14.2852 23.75 16.9375C23.75 18.0586 23.3125 19.0703 22.6289 19.8906Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDlpAttCommunicationGreen);
export default __webpack_public_path__ + "static/media/DlpAttCommunicationGreen.d6b8df68cadac4bc5b1d59a80101b0c1.svg";
export { ForwardRef as ReactComponent };